<div class="lost-card-content pointer-events-none" *ngIf="!isSeparateZone; else separateZoneTemplate">
  <div
    class="lost-widget-box"
    (click)="opeLostCardPopup()"
    [ngClass]="{
      'is-workflow': isWorkflow,
      'disable-widget': !isWidgetEnabled
    }"
  >
    <div class="widget-icon" [ngStyle]="borderStyle">
      <mat-icon class="lost-card" svgIcon="lost-card"></mat-icon>
    </div>
    <label for="title" class="label" [ngStyle]="textContentStyle" [ngClass]="{ 'is-workflow': isWorkflow }">
      Lost/Stolen
    </label>
  </div>
</div>

<ng-template #separateZoneTemplate>
  <div
    class="lost-card-content separate-zone pointer-events-none"
    [ngStyle]="contentStyle"
    style="height: 98%"
    [ngClass]="{
      'disable-widget': !isWidgetEnabled
    }"
  >
    <div class="list-box" (click)="opeLostCardPopup()">
      <div class="l-section">
        <div class="image">
          <mat-icon class="lost-card" svgIcon="lost-card"></mat-icon>
        </div>
      </div>
      <div class="center-section" style="width: 100%">
        <div class="title">Report Lost/Stolen Card</div>
        <div class="sub-title">Report for stolen card and issue a new one</div>
      </div>
    </div>
  </div>
</ng-template>
